module.exports = __webpack_public_path__ + "static/media/Sound.d73c27ed.svg";